import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { LEGACY_SECTION_ROUTE_MAP } from "./routesConfig";

export const useLegacySectionRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    const section = params.get("section");
    if (!section) return;
    const nextRoute = LEGACY_SECTION_ROUTE_MAP[section] || "/dashboard";
    navigate(nextRoute, { replace: true });
  }, [location.search, navigate]);
};
